import CommitmentSection from './CommitmentSection';
import DetailsSection from './DetailsSection';
import EventsSection from './EventsSection';
import ProjectsSection from './ProjectsSection';
import PublicationsSection from './PublicationsSection';
export default class RdPage {
    static fromApi(response) {
        const rdpage = new RdPage();
        if (response === null || response === void 0 ? void 0 : response.details)
            rdpage.details_section = DetailsSection.fromPartial(response.details);
        if (response === null || response === void 0 ? void 0 : response.commitment_section)
            rdpage.commitment_section = CommitmentSection.fromPartial(response.commitment_section);
        if (response === null || response === void 0 ? void 0 : response.project_section)
            rdpage.projects_section = ProjectsSection.fromPartial(response.project_section);
        if (response === null || response === void 0 ? void 0 : response.events_section)
            rdpage.events_section = EventsSection.fromPartial(response.events_section);
        if (response === null || response === void 0 ? void 0 : response.publication_section)
            rdpage.publications_section = PublicationsSection.fromPartial(response.publication_section);
        return rdpage;
    }
}
